'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LegendSvgItem = require('./LegendSvgItem');

var _LegendSvgItem2 = _interopRequireDefault(_LegendSvgItem);

var _compute = require('../compute');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegendSvg = function LegendSvg(_ref) {
    var data = _ref.data,
        x = _ref.x,
        y = _ref.y,
        direction = _ref.direction,
        _padding = _ref.padding,
        justify = _ref.justify,
        itemWidth = _ref.itemWidth,
        itemHeight = _ref.itemHeight,
        itemDirection = _ref.itemDirection,
        itemsSpacing = _ref.itemsSpacing,
        symbolSize = _ref.symbolSize,
        symbolSpacing = _ref.symbolSpacing,
        symbolShape = _ref.symbolShape;

    var _computeDimensions = (0, _compute.computeDimensions)({
        itemCount: data.length,
        itemWidth: itemWidth,
        itemHeight: itemHeight,
        itemsSpacing: itemsSpacing,
        direction: direction,
        padding: _padding
    }),
        width = _computeDimensions.width,
        height = _computeDimensions.height,
        padding = _computeDimensions.padding;

    var xStep = 0;
    var yStep = 0;
    if (direction === _constants.DIRECTION_ROW) {
        xStep = itemWidth + itemsSpacing;
    } else if (direction === _constants.DIRECTION_COLUMN) {
        yStep = itemHeight + itemsSpacing;
    }

    return _react2.default.createElement(
        'g',
        { transform: 'translate(' + x + ',' + y + ')' },
        data.map(function (_ref2, i) {
            var label = _ref2.label,
                fill = _ref2.fill;
            return _react2.default.createElement(_LegendSvgItem2.default, {
                key: i,
                x: i * xStep + padding.left,
                y: i * yStep + padding.top,
                width: itemWidth,
                height: itemHeight,
                symbolSize: symbolSize,
                symbolSpacing: symbolSpacing,
                symbolShape: symbolShape,
                direction: itemDirection,
                justify: justify,
                label: label,
                fill: fill
            });
        })
    );
}; /*
    * This file is part of the nivo project.
    *
    * Copyright 2016-present, Raphaël Benitte.
    *
    * For the full copyright and license information, please view the LICENSE
    * file that was distributed with this source code.
    */


LegendSvg.propTypes = {
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
        fill: _propTypes2.default.string.isRequired
    })).isRequired,

    // position/layout
    x: _propTypes2.default.number.isRequired,
    y: _propTypes2.default.number.isRequired,
    direction: _propTypes2.default.oneOf([_constants.DIRECTION_COLUMN, _constants.DIRECTION_ROW]).isRequired,
    padding: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
        top: _propTypes2.default.number,
        right: _propTypes2.default.number,
        bottom: _propTypes2.default.number,
        left: _propTypes2.default.number
    })]).isRequired,
    justify: _propTypes2.default.bool.isRequired,

    // items
    itemWidth: _propTypes2.default.number.isRequired,
    itemHeight: _propTypes2.default.number.isRequired,
    itemDirection: _propTypes2.default.oneOf([_constants.DIRECTION_LEFT_TO_RIGHT, _constants.DIRECTION_RIGHT_TO_LEFT, _constants.DIRECTION_TOP_TO_BOTTOM, _constants.DIRECTION_BOTTOM_TO_TOP]).isRequired,
    itemsSpacing: _propTypes2.default.number.isRequired,
    symbolSize: _propTypes2.default.number,
    symbolSpacing: _propTypes2.default.number,
    symbolShape: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};

LegendSvg.defaultProps = {
    // position/layout
    padding: 0,
    justify: false,

    // items
    itemDirection: _constants.DIRECTION_LEFT_TO_RIGHT,
    itemsSpacing: 0
};

exports.default = LegendSvg;


//////////////////
// WEBPACK FOOTER
// ./~/@nivo/legends/lib/svg/LegendSvg.js
// module id = 127
// module chunks = 168707334958949